const AddonBefore = ({width, external, style={}, children}) => {
    if(external) {
        return (
            <div className={'ant-input-number-group-addon'} style={{width: `${width}px`, border: '1px solid #d9d9d9', textAlign: 'start', ...style}}>
                {children}
            </div>
        )
    }

    return (
        <div style={{width, textAlign: 'start'}}>
            {children}
        </div>
    )
}

export default AddonBefore